import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { NewsletterCategory } from "src/app/intefaces/newsletter-category";
import { HttpAlertService } from "src/app/services/http-alert.service";
import { NewsletterService } from "src/app/services/newsletter.service";

@Component({
  selector: "app-newsletter-create",
  templateUrl: "./newsletter-create.component.html",
  styleUrls: ["./newsletter-create.component.scss"],
})
export class NewsletterCreateComponent implements OnInit {
  model = {
    id: null,
    subject: "",
    content: "",
    date_from: "",
    shipping_time: "",
    every_day_count: 7,
    category_id: null,
    is_active: false,
  };
  categories: NewsletterCategory[] = [];
  id: string = this.route.snapshot.paramMap.get("id");

  private subscription: Subscription = new Subscription();
  constructor(
    private readonly newsletterService: NewsletterService,
    private alterService: HttpAlertService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getCategories();
  }

  private getCategories() {
    const sub = this.newsletterService
      .getCategories(true, null, null)
      .subscribe({
        next: (data) => {
          this.categories = data.data.categories;
        },
        complete: () => {
          if (this.id) {
            this.getById();
          }
        },
      });
    this.subscription.add(sub);
  }

  onSave() {
    this.newsletterService.saveNewsletter(this.model).subscribe({
      next: (response) => {
        this.model = response.data;
        this.model.category_id = {
          id: this.model.category_id,
        };
        this.alterService.success("Zapisno.");
      },
    });
  }

  private getById() {
    this.newsletterService.getById(this.id).subscribe({
      next: (response) => {
        this.model = response.data.newsletter;
        this.model.category_id = {
          id: this.model.category_id,
        };
      },
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
